import { useMutation } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { profilePaths } from '../queries/paths';

// TSS vite/03 — server-state mutation for the client's own profile.
// PATCH public/me edita SOLO name/phone (contract Q-101); email/document/role/
// status/etc. se descartan server-side (stripUnknown), nunca llegan al UPDATE.
// Devuelve el perfil ensamblado (forma de GET /me, SIN sobre — identidad).
//
// CSRF y el header X-CSRF-Token los pone el api client central (core/network).
// Errores → ApiError: validación 400 { fields }, sin CSRF 403, writeLimiter 429.
// No hay caché de query que invalidar (el perfil vive en el AuthProvider); el
// caller aplica el perfil devuelto vía useAuth().updateUser en onSuccess.
export function useUpdateProfile(options = {}) {
    return useMutation({
        mutationFn: (patch) => api.patch(profilePaths.me(), patch).then((r) => r.data),
        ...options,
    });
}
